import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { SocieteModel } from '@shared/societe';
import { Observable } from 'rxjs';
import { AppConsts } from '@shared/app-consts';
import { KeyValueObject } from '@shared/models/common/KeyValueObject.model';

@Injectable({
  providedIn: 'root',
})
export class PortageService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  getSocieteClientePortage(): Observable<any> {
    const httpOptions = this.getHttpHeader();
    return this.http.get(AppConsts.API_SERVICE_URL + 'portage/listSocieteClientePortageAsKeyValueObject', httpOptions);
  }
    getSocieteClientePortage1(): Observable<any> {
    const httpOptions = this.getHttpHeader();
    return this.http.get(AppConsts.API_SERVICE_URL + 'portage/listSocieteClientePortageAsKeyValueObject1', httpOptions);
  }
  getApiPortageParameters(): Observable<any> {
    const httpOptions = this.getHttpHeader();
    return this.http.get(AppConsts.API_SERVICE_URL + 'portage/GetApiPortageaParameters', httpOptions);
  }
}
